const conditionOperatorTypes = {
    if: {
        text: 'IF',
        value: 0,
        stringValue: '0'
    },
    ifNot: {
        text: 'IF NOT',
        value: 1,
        stringValue: '1'
    }
};

const conditionOperatorTypesArray = Object.values(conditionOperatorTypes);
const conditionOperatorTypesByValue = conditionOperatorTypesArray.reduce((byValue, operatorType) => {
    byValue[operatorType.value] = operatorType;
    return byValue;
}, {});

export {
    conditionOperatorTypes,
    conditionOperatorTypesArray,
    conditionOperatorTypesByValue
};